module.exports = __webpack_public_path__ + "static/img/qiniu.73c18cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qiniu.png
// module id = Xmhi
// module chunks = 13